import Vue from "vue"
import moment from "moment"
import payChannel from "../constants/pay-channel"

export function injectFilters() {
  /**
   * 金额格式化为（加入千分分隔符及精确两位小数
   */
  Vue.filter("currency", function(num) {
    let value = parseFloat(num).toFixed(2)
    let parts = value.toString().split(".")
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return parts.join(".")
  })

  /**
   * 状态映射表
   * 根据状态码返回订单/开发票的状态
   */
  Vue.filter("invoiceStatusFilter", (status, type) => {
    const statusMap = {
      // 返回开票记录里的开票状态
      // -3-申请失败 -2-已驳回 -1-已退票 0-初始态 1-开票中 2-待领取 3-已开票 4-待下载
      // (0，1，4前端均展示为开票中，2，3前端均展示为已开票)
      invoice_water_query: {
        "-3": "申请失败",
        "-2": "已驳回",
        "-1": "已退票",
        "0": "开票中",
        "1": "开票中",
        "2": "已开票",
        "3": "已开票",
        "4": "开票中",
        "99": "未开票"
      }
    }
    return statusMap[type][status]
  })

  /**
   * 日期映射表 dateFilter
   * 根据时间戳格式化时间日期
   */
  Vue.filter("dateFilter", timeStamp => {
    if (timeStamp) {
      return moment(timeStamp * 1000).format("YYYY-MM-DD HH:mm")
    }
  })

  /**
   * 支付渠道筛选 payChannelFilter
   * 根据英文映射中文
   */
  Vue.filter("payChannelFilter", detail => {
    let channel = detail.payChannel
    const subChannel = detail.payChannelSubId

    if (channel === "bank") {
      channel = `bank:${subChannel}`
    }

    if (channel) {
      return payChannel[channel] ? payChannel[channel] : payChannel["other"]
    }
  })

  /**
   * 查询用户的金额展示 payAmtFilter
   * Qb 和 现金分开展示消耗内容
   */
  Vue.filter("payAmtFilter", payAmt => {
    return payAmt / 100
  })
}
